(function () {
  'use strict';

  function initGallery(root) {
    var gallery = root.querySelector('[data-cn-gallery]');
    if (!gallery) return;
    var slides = gallery.querySelectorAll('[data-cn-slide]');
    var thumbs = gallery.querySelectorAll('[data-cn-thumb]');
    var track = gallery.querySelector('[data-cn-thumbs]');
    var current = 0;
    if (slides.length < 2) return;

    function go(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) {
        var on = idx === current;
        s.classList.toggle('is-active', on);
        var vid = s.querySelector('video');
        if (vid && !on) vid.pause();
      });
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === current); });
      var active = thumbs[current];
      if (active && track) {
        track.scrollTo({ left: active.offsetLeft - track.clientWidth / 2 + active.clientWidth / 2, behavior: 'smooth' });
      }
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-cn-thumb'), 10)); });
    });
    var prev = gallery.querySelector('[data-cn-prev]');
    var next = gallery.querySelector('[data-cn-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });

    var viewport = gallery.querySelector('.cn-gallery__viewport');
    var startX = 0, startY = 0;
    viewport.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
    }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? current + 1 : current - 1);
    }, { passive: true });
  }

  function initVariants(root) {
    var radios = root.querySelectorAll('[data-cn-variant]');
    var idInput = root.querySelector('[data-cn-id]');
    if (!radios.length || !idInput) return;
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        idInput.value = r.value;
        root.querySelectorAll('.cn-variant').forEach(function (l) { l.classList.remove('is-active'); });
        r.closest('.cn-variant').classList.add('is-active');
        if (root.dataset.priceLocked !== 'true') {
          root.querySelectorAll('[data-cn-price]').forEach(function (el) { el.textContent = r.dataset.price; });
        }
        root.querySelectorAll('[data-cn-compare]').forEach(function (el) {
          el.textContent = r.dataset.compare || '';
          el.hidden = !r.dataset.compare;
        });
        var pct = root.querySelector('[data-cn-pct]');
        if (pct) {
          pct.hidden = !r.dataset.pct;
          var num = pct.querySelector('[data-cn-pct-num]');
          if (num) num.textContent = r.dataset.pct || '';
        }
      });
    });
  }

  function initCheckoutMode(root) {
    if (root.dataset.ctaMode !== 'checkout') return;
    var form = root.querySelector('[data-cn-form]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-cn-main-btn]');
      var id = form.querySelector('[data-cn-id]').value;
      if (btn) btn.disabled = true;
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (res) { if (!res.ok) throw new Error('add'); window.location.href = base + 'checkout'; })
        .catch(function () { if (btn) btn.disabled = false; form.submit(); });
    });
  }

  var COD_TRIGGERS = [
    '[class*="easysell"][class*="button"]', '[id*="easysell"][id*="button"]',
    '.easysell-cod-form-btn', '.easysell-buy-button', '.esf-trigger', '[class*="esf-"][class*="button"]',
    '.releasit-cod-form-button', '[class*="cod-form"] button', '[class*="cod-button"]',
    '[class*="cod"][class*="trigger"]'
  ];
  var COD_FORMS = [
    '[id*="easysell-cod-form"]', '[class*="easysell-cod-form"]', '#easysell-cod-form',
    '[class*="easysell"][class*="form"]', '[class*="releasit-cod-form"]', '[class*="cod-form"]', 'form[class*="cod"]'
  ];

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return el.offsetParent !== null && r.height > 0 && r.width > 0;
  }

  function findFirst(list) {
    for (var i = 0; i < list.length; i++) {
      var found = document.querySelectorAll(list[i]);
      for (var j = 0; j < found.length; j++) {
        if (visible(found[j])) return found[j];
      }
    }
    return null;
  }

  /* El formulario COD casi siempre es el único con un campo de teléfono */
  function findPhoneForm(root) {
    var nodes = document.querySelectorAll('form, [class*="form"]');
    for (var i = 0; i < nodes.length; i++) {
      var f = nodes[i];
      if (!visible(f)) continue;
      if (f.closest('header, footer, .cn-form')) continue;
      if (f.querySelector('input[type="tel"], input[name*="phone" i], input[id*="phone" i], input[name*="telefono" i], input[placeholder*="eléfono" i]')) {
        return f;
      }
    }
    return null;
  }

  /* Algunas apps exponen una API global */
  function openCodApi() {
    var candidates = [window.EasySell, window.easysell, window.ESF, window.Releasit, window.CODForm];
    for (var i = 0; i < candidates.length; i++) {
      var api = candidates[i];
      if (!api) continue;
      var fns = ['open', 'openForm', 'show', 'showForm', 'openPopup'];
      for (var j = 0; j < fns.length; j++) {
        if (typeof api[fns[j]] === 'function') {
          try { api[fns[j]](); return true; } catch (e) {}
        }
      }
    }
    return false;
  }

  function initScroll(root) {
    var buy = root.querySelector('[data-cn-buy]');
    var mainBtn = root.querySelector('[data-cn-main-btn]');
    var form = root.querySelector('[data-cn-form]');
    var mode = root.dataset.secondaryAction || 'auto';
    var customSel = (root.dataset.codSelector || '').trim();
    var suppressSubmit = false;

    /* Evita que el clic simulado envíe el formulario nativo y lleve al carrito */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (suppressSubmit) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    }

    function scrollToBuy() {
      if (!buy) return;
      buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (mainBtn) {
        mainBtn.classList.remove('is-pulse');
        setTimeout(function () { mainBtn.classList.add('is-pulse'); }, 500);
      }
    }

    function focusForm(el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () {
        var field = el.querySelector('input:not([type="hidden"]):not([disabled]), select, textarea');
        if (field) field.focus({ preventScroll: true });
      }, 600);
    }

    function clickMain() {
      if (!mainBtn) return false;
      suppressSubmit = true;
      mainBtn.click();
      setTimeout(function () { suppressSubmit = false; }, 1200);
      return true;
    }

    function openCod() {
      if (customSel) {
        var custom = document.querySelector(customSel);
        if (custom) {
          var tag = custom.tagName;
          if (tag === 'BUTTON' || tag === 'A' || custom.getAttribute('role') === 'button') custom.click();
          else focusForm(custom);
          return true;
        }
      }
      if (openCodApi()) return true;
      var trigger = findFirst(COD_TRIGGERS);
      if (trigger) { trigger.click(); return true; }
      var phoneForm = findPhoneForm(root);
      if (phoneForm) { focusForm(phoneForm); return true; }
      var codForm = findFirst(COD_FORMS);
      if (codForm) { focusForm(codForm); return true; }
      return false;
    }

    root.querySelectorAll('[data-cn-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (mode === 'scroll') { scrollToBuy(); return; }
        if (mode === 'click') { if (!clickMain()) scrollToBuy(); return; }
        if (!openCod()) { if (!clickMain()) scrollToBuy(); }
      });
    });
  }

  function initSticky(root) {
    var sticky = root.querySelector('[data-cn-sticky]');
    var target = root.querySelector('[data-cn-main-btn]');
    if (!sticky || !target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      var show = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      var link = sticky.querySelector('a');
      if (link) link.tabIndex = show ? 0 : -1;
    }).observe(target);
  }

  function initComments(root) {
    var wrap = root.querySelector('[data-cn-carousel]');
    if (!wrap) return;
    var track = wrap.querySelector('[data-cn-c-track]');
    var items = track.querySelectorAll('[data-cn-c-item]');
    var prev = wrap.querySelector('[data-cn-c-prev]');
    var next = wrap.querySelector('[data-cn-c-next]');
    var dotsWrap = root.querySelector('[data-cn-c-dots]');
    if (!items.length) return;

    function step() {
      var first = items[0];
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 20) || 20;
      return first.getBoundingClientRect().width + gap;
    }

    function currentIndex() {
      return Math.round(track.scrollLeft / step());
    }

    function goTo(i) {
      var max = items.length - 1;
      i = Math.max(0, Math.min(max, i));
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });

    var dots = [];
    if (dotsWrap && items.length > 1) {
      items.forEach(function (item, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'cn-fbc__dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Comentario ' + (i + 1));
        d.addEventListener('click', function () { goTo(i); });
        dotsWrap.appendChild(d);
        dots.push(d);
      });
    }

    function sync() {
      var i = currentIndex();
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    wrap.querySelectorAll('[data-cn-like]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('[data-cn-c-item]');
        var count = card.querySelector('[data-cn-like-count]');
        var liked = btn.classList.toggle('is-liked');
        if (count) count.textContent = Number(count.textContent) + (liked ? 1 : -1);
      });
    });
  }

  function initFaq(root) {
    var items = root.querySelectorAll('[data-cn-faq] details');
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  function init(root) {
    if (root.dataset.cnReady) return;
    root.dataset.cnReady = '1';
    initGallery(root);
    initVariants(root);
    initCheckoutMode(root);
    initScroll(root);
    initSticky(root);
    initComments(root);
    initFaq(root);
  }

  function boot() { document.querySelectorAll('[data-cn-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
